import { FunnelChartData, ReportData } from '@/types/domain';
import { FunnelChart } from './FunnelChart';

type CrmLibraryItemFunnelPreviewProps ={
  visibleColumns: string[];
  reportData?: ReportData | null;
  pipelineLabel?: string;
  theme?: string;
}

export const CrmLibraryItemFunnelPreview = ({ visibleColumns, reportData, pipelineLabel, theme }: CrmLibraryItemFunnelPreviewProps) => {
  
  // Convert report data to funnel chart format
  const generateFunnelDataFromReport = (): FunnelChartData | null => {
    if (!reportData || !reportData.columns || !reportData.rows || reportData.columns.length === 0 || reportData.rows.length === 0) {
      return null;
    }

    // Parse the report data - each row has cells array
    const numColumns = reportData.columns.length;
    
    // Need at least 2 columns (1 for labels, 1+ for data)
    if (numColumns < 2) {
      return null;
    }
    
    // Extract labels from first column of each row
    const labels = reportData.rows.map((row: any) => {
      if (row.cells && row.cells.length > 0) {
        return row.cells[0].value;
      }
      return 'Unknown';
    });

    // Create charts for each visible column (skip first column which is labels)
    const charts = [];
    for (let colIndex = 1; colIndex < numColumns; colIndex++) {
      const colLabel = reportData.columns[colIndex].name;

      const data = reportData.rows.map((row: any, rowIndex: number) => {
        if (row.cells && row.cells.length > colIndex) {
          const rawValue = row.cells[colIndex].value;
          const numericValue = parseFloat(rawValue.replace(/[^0-9.-]/g, '')) || 0;
          return {
            id: `item-${rowIndex}`,
            label: labels[rowIndex] || `Item ${rowIndex + 1}`,
            value: numericValue,
            formattedvalue: rawValue
          };
        }
        return {
          id: `item-${rowIndex}`,
          label: labels[rowIndex] || `Item ${rowIndex + 1}`,
          value: 0,
          formattedvalue: '0'
        };
      });

      if (data.length > 0) {
        charts.push({
          data: data,
          chartElementId: `funnel-preview-${colIndex}`,
          legendElementId: `funnellegend-preview-${colIndex}`,
          title: pipelineLabel + ' - ' + colLabel
        });
      }
    }

    if (charts.length === 0) {
      return null;
    }

    return {
      libraryItemId: 'preview',
      wrapperElementId: 'funnelWrapper-preview',
      charts: charts,
    };
  };

  if (visibleColumns.length === 0) {
    return (
      <div className="p-4">
        <div className="text-center py-8 text-gray-500">
          <p>Select columns to see funnel visualizations</p>
        </div>
      </div>
    );
  }

  const funnelData = generateFunnelDataFromReport();
  
  if (!funnelData) {
    return (
      <div className="bg-gray-50 rounded-lg p-8 text-center">
        <p className="text-gray-500">No data available</p>
      </div>
    );
  }
  
  return <FunnelChart data={funnelData} theme={theme} />;
};